import { defineStore } from 'pinia'
import { ref, toRef } from 'vue'

export const useToast = defineStore('toast', () => {
    const show = ref(false)
    const title = ref('')
    const message = ref('')
    const status = ref<'success' | 'error' | 'info'>('success')
    const timeout = ref(5000)
    const showToast = (
        title2: string,
        message2: string,
        status2: 'success' | 'error' | 'info',
        timeout2 = 5000
    ) => {
        show.value = true
        title.value = title2
        message.value = message2
        status.value = status2
        timeout.value = timeout2
    }

    return { showToast, show: toRef(show), title, message, status, timeout }
})
